//src/store/homeStore.js
import { defineStore } from 'pinia'

export const useProductsStore = defineStore('productsStore', {
    state: () => ({
        isLoaded: false,       // 是否已經撈過資料
        products: [],
        productsTypes: []
    }),
    actions: {
        async fetchProductsData() {
            if (this.isLoaded) return // 已載入過就直接 return
            try {
                const res = await fetch('/api/load/loadProducts')
                const json = await res.json()
                if (json.success) {
                    this.products = json.products
                    this.productsTypes = json.productsTypes
                    this.isLoaded = true  // 標記為「已載入」
                } else {
                    console.warn('取得輪播資料失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },
    },
})
